import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

import { useField } from "vee-validate";



export default /*#__PURE__*/_defineComponent({
  __name: 'AbitSwitch',
  props: {
    name: {},
    label: {},
    placeholder: {},
    required: { type: Boolean },
    horizontal: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emitInput = __emit;

const props = __props;

const handleChange = (newValue: string) => {
    value.value = newValue;
    emitInput("update:modelValue", newValue);
};


const { value, errorMessage } = useField<string>(props.name);

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (!_ctx.horizontal)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("label", {
          class: _normalizeClass(['form-label', props.required && 'required'])
        }, _toDisplayString(props.label), 3),
        _createVNode(_component_el_form_item, {
          error: _unref(errorMessage),
          validateStatus: _unref(errorMessage) ? 'error' : 'success'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, _mergeProps({
              name: props.name
            }, props, {
              "model-value": _unref(value),
              onChange: handleChange
            }), null, 16, ["name", "model-value"])
          ]),
          _: 1
        }, 8, ["error", "validateStatus"])
      ], 64))
    : (_openBlock(), _createBlock(_component_el_form_item, {
        key: 1,
        error: _unref(errorMessage),
        validateStatus: _unref(errorMessage) ? 'error' : 'success'
      }, {
        default: _withCtx(() => [
          _createElementVNode("label", {
            class: _normalizeClass(['form-label', _ctx.horizontal && 'horizontal', props.required && 'required'])
          }, [
            _createTextVNode(_toDisplayString(props.label) + " ", 1),
            _createVNode(_component_el_switch, _mergeProps({
              name: props.name
            }, props, {
              "model-value": _unref(value),
              onChange: handleChange
            }), null, 16, ["name", "model-value"])
          ], 2)
        ]),
        _: 1
      }, 8, ["error", "validateStatus"]))
}
}

})